import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("linearGradient", {
  fill: "currentColor",
  id: "a",
  gradientUnits: "userSpaceOnUse",
  x1: "100",
  y1: "616.461",
  x2: "100",
  y2: "756",
  gradientTransform: "translate(0 -566)"
}, [
  /*#__PURE__*/_createElementVNode("stop", {
    fill: "currentColor",
    offset: "0"
  }),
  /*#__PURE__*/_createElementVNode("stop", {
    fill: "currentColor",
    offset: "1"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M167.5 34.4c-.4-.1-44.1-9.5-64.2-23.5-1.8-1.2-4.1-1.3-5.9 0-20.6 14-64.6 23.4-65 23.5-2.5.5-4.3 2.9-4.3 5.6v79.3c0 28.6 38.5 70.7 73.1 70.7 34.4 0 70.7-46 70.7-70.7V40c-.1-2.7-1.9-5-4.4-5.6zM120 65c2.6 1.5 3.6 4.9 2.2 7.7l-2.8 5.5h4.1c1.9 0 3.7 1.1 4.7 2.8 1 1.7 1 3.9 0 5.6l-14.3 26c-1 1.8-2.8 2.8-4.7 2.8-.9 0-1.8-.2-2.7-.7-2.6-1.6-3.5-5-2-7.7l9.6-17.4h-3.9c-1.9 0-3.7-1-4.6-2.7-1-1.7-1-3.8-.1-5.6l7.1-13.8c1.5-3 4.7-4 7.4-2.5zm-20.6 83.9c-18.2 0-33-15.5-33-34.6-.1-17.1 25.5-58.8 28.5-63.5 1-1.6 2.7-2.6 4.5-2.6h.1c1.9 0 3.6 1 4.5 2.7 0 0 2.3 4 6.1 10.4 1.5 2.7.7 6.1-1.9 7.8-2.6 1.6-5.9.7-7.4-1.9-.5-.9-1-1.7-1.5-2.6-10 17.1-22.1 40.8-22.1 49.8 0 12.8 10 23.3 22.2 23.3s22.2-10.5 22.2-23.3c0-1.4-.4-2.8-1.2-5.7-.9-3 .7-6.1 3.6-7.1 2.9-.9 5.9.7 6.8 3.7 1 3.4 1.7 6 1.7 9.1-.1 19-14.9 34.5-33.1 34.5z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "tri-icon",
    style: _normalizeStyle(`font-size: ${_ctx.size}; color: ${_ctx.color}; width: 1em; height: 1em; display:block; line-height: 0;`)
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
  ], 4))
}